import {SET_LEAD_FILTER_PARAMS} from "./types";

export const setLeadFilterParams = params => dispatch => dispatch({type: SET_LEAD_FILTER_PARAMS, params});
